<template>
  <router-link :to="`/properties/view/${property.id}`">
    <div class="property-box-style">
      <div class="p-3">
        <div class="image">
          <div
            class="image-holder"
            :style="
              `background-image: url(${baseImageUrl}/storage/${
                property.photos.length ? property.photos[0].image : ''
              });`
            "
          />
          <div class="overlay">
            <div class="tags">
              <ul>
                <li>{{ LISTING_TYPES[property.listing_type] }}</li>
                <li v-if="property.is_advertised">Featured</li>
              </ul>
            </div>
            <div class="price">
              &euro;{{ property.price }} <small class="font-normal"> monthly</small>
            </div>
          </div>
        </div>
      </div>
      <div class="p-5 py-3 mb-2">
        <p class="mb-1 capitalize">
          {{ property.property_type.classification }} -
          {{ property.property_type.name }}
        </p>
        <h4 class="font-bold mb-2">{{ property.city.name }}</h4>
        <p class="mb-5">
          {{ property.description }}
        </p>
        <ul>
          <li>Baths: {{ property.main_bathrooms + property.ensuites }}</li>
          <li>Beds: {{ property.bedrooms }}</li>
        </ul>
      </div>
    </div>
  </router-link>
</template>

<script>
import { LISTING_TYPES } from "@/constants";
export default {
  props: ["property"],
  data: function() {
    return {
      LISTING_TYPES,
      baseImageUrl: process.env.VUE_APP_API_URL,
    };
  },
};
</script>

<style lang="scss" scoped>
.property-box-style {
  @apply bg-white border border-gray-400 rounded-lg;

  .image {
    @apply relative rounded-lg overflow-hidden;

    .image-holder {
      width: 100%;
      height: 220px;
      background-size: cover;
      background-position: center;
    }

    .overlay {
      @apply absolute top-0 w-full h-full bg-black bg-opacity-30 text-white;

      .tags {
        @apply absolute w-full top-0 px-4 py-4;

        ul li {
          @apply inline-block bg-black px-3 py-1 text-xs rounded-md mr-2;

          &:last-child {
            @apply text-black bg-primary-color;
          }
          &:first-child {
            @apply text-white bg-black;
          }
        }
      }
      .price {
        @apply absolute w-full bottom-0 px-6 py-3 text-2xl font-bold;
      }
    }
  }

  ul li {
    @apply inline-block pr-8;
  }
}
</style>
